const POTENCY = 'potencyProfile';
const TERPENES = 'terpeneProfile';
const MICRO = 'microbiology';
const PESTICIDES = 'pesticideResidue';
const PESTICIDES_MORE = 'pesticidesResidueMore';
const RESIDUAL_SOLVENTS = 'residueSolvents';
const HEAVY_METALS = 'heavyMetals';
const MYCOTOXINS = 'mycotoxins';
const SULFUR = 'sulfur';
const WATER_ACTIVITY = 'waterActivity';
const MOISTURE = 'moisture';
const FOREIGN_MATERIALS = 'foreignMaterials';
const ALKALOID = 'alkaloid';
const COLIFORM_AND_ECOLI = 'coliform_and_ecoli';
const YEAST_AND_MOLD = 'yeast_and_mold';
const SALMONELLA = 'salmonella';
const ANISIDINE = 'anisidine';
const OTHER_ANALYSES = 'otherAnalyses'; // Water Activity, Moisture, Foreign Materials, Alkaloid Profiles

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
		.service('DownloadSampleService', function () {
			this.showToast = function(message, className) {
				var toastContainer = document.getElementById('toast-container');
				var toast = document.createElement('div');
				toast.className = 'toast ' + className; 
				toast.textContent = message;
				toastContainer.appendChild(toast);
				setTimeout(function() {
					toastContainer.removeChild(toast);
				}, 3000); 
			};
			this.info = function(message) {
				this.showToast(message, 'info-toast');
			};
			this.error = function(message) {
				this.showToast(message, 'error-toast');
			};
		})
        .controller('SampleLogController', SampleLogController)
        .directive('hoverSampleResults', function(){
        	return {
        		link: function ($scope, element, attrs){
        			setTimeout(function(){
        				var $el = $('.hover-sample-results-' + attrs.hoverSampleIndex);
            			element.bind('mouseenter', function(event){
            				// Trigger lazy load of test results for this sample (Tier 3)
            				var sample = $scope.sample;
            				var vm = $scope.vm;
            				if (vm && vm.loadTestResultsForHover && (!sample.sampleTests || sample.sampleTests.length === 0)) {
            					vm.loadTestResultsForHover(sample);
            				}

            				$el.offset({top: event.pageY - $el.height()/2});
            				// Determine if part of div is offscreen
            				$el.show();
            				var docViewTop = $(window).scrollTop();
            				var docViewBottom = docViewTop + $(window).height();

            				var elemTop = $el.offset().top;
            				var elemBottom = elemTop + $el.height();

            				if (elemBottom > docViewBottom - 48){
            					$el.offset({top: docViewBottom - $el.height() - 48});
            				} else if (elemTop < docViewTop){
            					$el.offset({top: docViewTop + 24});
            				}

            				var elemLeft = $el.offset().left;
            				var elemRight = elemLeft + $el.width();

            				if (elemRight > window.innerWidth) {
            					$el.offset({left: window.innerWidth - $el.width() - 48});
            				} else if (elemLeft < 0) {
            					$el.offset({left: 24});
            				}

            			});

            			element.bind('mouseleave', function(event) {
            				var pointerEl = document.elementFromPoint(event.clientX, event.clientY);
            				if (pointerEl && pointerEl.closest('.hover-sample-results-div')) {
            					// do nothing
            				} else {
            					$el.hide();
            				}
            			});
            			$el.bind('mouseleave', function(){
            				$el.hide();
            			});

        			}, 1000);

        		}
        	}

        }).directive('hoverDisplayResults', function() {
        	return {
        		scope: {sample: '=', determineTestPf: '='},
        		link: function(scope, element, attrs) {
        			function renderTests() {
        				var html = '';
        				if (scope.sample && scope.sample.sampleTests && scope.sample.sampleTests.length > 0) {
        					scope.sample.sampleTests.forEach(function(test) {
        						html += scope.determineTestPf(test, scope.sample);
        					});
        				} else if (scope.sample && scope.sample.testsLoading) {
        					html = '<tr><td colspan="2" style="color:#999;text-align:center;">Loading...</td></tr>';
        				}
        				element.html(html);
        			}

        			// Watch for changes to sampleTests (loaded async on hover)
        			scope.$watch('sample.sampleTests', function(newVal, oldVal) {
        				renderTests();
        			}, true);

        			// Also watch testsLoading for loading state
        			scope.$watch('sample.testsLoading', function(newVal, oldVal) {
        				if (newVal) {
        					renderTests();
        				}
        			});

        			// Initial render
        			renderTests();
				}
			}
        }).directive('displaySampleStatus', function(){
        	return {
            	scope: {sample: '='},
            	link: function(scope, element, attrs) {




                	var PASS_HTML = '<span class="sample-pass"><span class="fa fa-check-circle" title="Pass"></span>&nbsp; </span>';
                	var FAIL_HTML = '<span class="sample-fail"><span class="fa fa-times-circle" title="Fail"></span>&nbsp; </span>';
                	var IN_PROGRESS_HTML = '<span class="sample-in-progress"><span class="fa fa-clock-o" title="In Progress"></span>&nbsp; </span>';
                	var NO_STATUS_HTML = '<span class="sample-no-status"><span class="fa fa-stop-circle" style="color: gray;"></span>&nbsp; </span>';
                	var CAUTION_HTML = '<span class="sample-caution"><span class="fa fa-warning" title="Caution">&nbsp; </span></span>';
					var HOLD_HTML = '<span class="sample-hold"><span class="fa fa-pause-circle" title="Hold">&nbsp; </span></span>';
                    var RETESTING_HTML = '<span class="sample-retesting"><span class="fa fa-repeat" title="Retesting">&nbsp; </span></span>';
					var TESTED_HTML = '<span class="sample-tested"><span class="fa fa-stop-circle" title="Tested"></span>&nbsp; </span>';

					var sample = scope.sample;
					var status = scope.sample.status;
					var sampleTest = scope.sample.sampleTests[0];
					var hasEstimatedDate = sampleTest && sampleTest.estimatedCompleteDate;
					var hasReceivedDate = !!(sample && (sample.receivedDate || sample.orderDateReceived ||
						(sample.order && (sample.order.dateReceived || sample.order.date_received)) ||
						(sample.customerOrder && (sample.customerOrder.dateReceived || sample.customerOrder.date_received))));

                	if (sample.rd) {
                		if (sample.complete) {
					if (sampleTest && sampleTest.worksheetData) {
						if (sampleTest.worksheetData.do_not_show_pass_fail_in_portal) {
							if (sampleTest.worksheetData.do_not_show_pass_fail_in_portal.value){
								if (status === 'COMPLETED') element.html(TESTED_HTML);
								if (status === 'PASS') element.html(TESTED_HTML);
                					if (status === 'FAIL') element.html(TESTED_HTML);
                                    if (status === 'IN_PROGRESS') element.html((hasReceivedDate && hasEstimatedDate) ? IN_PROGRESS_HTML : NO_STATUS_HTML);
                					if (status === 'NO_STATUS') element.html(NO_STATUS_HTML);
                					if (status === 'CAUTION') element.html(CAUTION_HTML);
                					if (status === 'RETESTING') element.html(RETESTING_HTML);
								if (status === 'HOLD') element.html(HOLD_HTML);

							}
							else {
								if (status === 'COMPLETED') element.html(TESTED_HTML);
								if (status === 'PASS') element.html(PASS_HTML);
                					if (status === 'FAIL') element.html(FAIL_HTML);
	                                    if (status === 'IN_PROGRESS') element.html((hasReceivedDate && hasEstimatedDate) ? IN_PROGRESS_HTML : NO_STATUS_HTML);
                					if (status === 'NO_STATUS') element.html(NO_STATUS_HTML);
                					if (status === 'CAUTION') element.html(CAUTION_HTML);
                					if (status === 'RETESTING') element.html(RETESTING_HTML);
								if (status === 'HOLD') element.html(HOLD_HTML);

							}
						}
						else {
							if (status === 'COMPLETED') element.html(TESTED_HTML);
							if (status === 'PASS') element.html(PASS_HTML);
                					if (status === 'FAIL') element.html(FAIL_HTML);
                					if (status === 'IN_PROGRESS') element.html(IN_PROGRESS_HTML);
                					if (status === 'NO_STATUS') element.html(NO_STATUS_HTML);
                					if (status === 'CAUTION') element.html(CAUTION_HTML);
                					if (status === 'RETESTING') element.html(RETESTING_HTML);
								if (status === 'HOLD') element.html(HOLD_HTML);

						}
					}
					else {
						// R&D sample is complete but has no worksheet data yet - show gray icon
						if (status === 'COMPLETED') element.html(TESTED_HTML);
						if (status === 'PASS') element.html(PASS_HTML);
						if (status === 'FAIL') element.html(FAIL_HTML);
						if (status === 'CAUTION') element.html(CAUTION_HTML);
						if (status === 'RETESTING') element.html(RETESTING_HTML);
						if (status === 'HOLD') element.html(HOLD_HTML);
					}
                		}
					else {
								if (status) element.html((hasReceivedDate && hasEstimatedDate) ? IN_PROGRESS_HTML : NO_STATUS_HTML);
                            if (status === 'RETESTING') element.html(RETESTING_HTML);
						    if (status === 'HOLD') element.html(HOLD_HTML);

                		}
                	}
					else {
                		if (sample.complete && sample.canSeeReport) {
							if (status === 'COMPLETED') element.html(TESTED_HTML);
                			if (status === 'PASS') element.html(PASS_HTML);
                			if (status === 'FAIL') element.html(FAIL_HTML);
                			if (status === 'IN_PROGRESS') element.html(IN_PROGRESS_HTML);
                			if (status === 'CAUTION') element.html(CAUTION_HTML);
                			if (status === 'RETESTING') element.html(RETESTING_HTML);
							if (status === 'HOLD') element.html(HOLD_HTML);

                		}
						else {
								if (status) element.html((hasReceivedDate && hasEstimatedDate) ? IN_PROGRESS_HTML : NO_STATUS_HTML);
                            if (status === 'RETESTING') element.html(RETESTING_HTML);
							if (status === 'HOLD') element.html(HOLD_HTML);
							if (status === 'COMPLETED') element.html(TESTED_HTML);
                		}
                	}

            	}
        	}
        });

    SampleLogController.$inject = ['$state','$stateParams','$scope','$rootScope', '$filter', '$timeout', 'Sample', 'SampleSearch', 'ParseLinks', 'DateUtils',
        'AlertService', 'paginationConstants', 'pagingParams','Auth', 'Principal', 'ProfileService', 'LoginService', 'SampleFilter', 'Weedmaps',
        'CustomerByUser','SampleAttach','SampleAttachDownload', 'SampleExportService', 'ProductType', 'ProductCategory','ProductTypeByCategory', 'SampleService', 'SampleCoaPdfService','DownloadSampleService','$translate','DownloadUtil', 'GraphQLService'];

    function SampleLogController($state, $stateParams,$scope, $rootScope, $filter, $timeout, Sample, SampleSearch, ParseLinks, DateUtils, AlertService,
                                 paginationConstants, pagingParams,Auth, Principal, ProfileService, LoginService, SampleFilter, Weedmaps,
                                 CustomerByUser,SampleAttach,SampleAttachDownload, SampleExportService, ProductType, ProductCategory,
                                 ProductTypeByCategory, SampleService, SampleCoaPdfService,DownloadSampleService, $translate, DownloadUtil, GraphQLService) { /*,Auth, Principal, ProfileService, LoginService*/

		var vm = this;
		vm.currentLanguage = $translate.proposedLanguage();
        $rootScope.showSearch = pagingParams.search;
        vm.search = search;
        vm.clear = clear;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.pagingParams = pagingParams;

        // DownloadUtil provides getFilenameFromContentDisposition

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;

        vm.getAttachmentsLoader = false;
        vm.itemsPerPage = "10";

        // Initialize column visibility flags to show by default (will be adjusted by getCustomerData for food customers)
        vm.sampleColumnThc = true;
        vm.sampleColumnCbd = true;
        vm.sampleColumnAlkaloids = false;
        vm.sampleColumnMitragynine = false;
        vm.thcCbdFilterOptions = true;

        // Initialize customerData with default consolidated_business_type so columns show immediately
        vm.customerData = { consolidated_business_type: 'cannabis' };

        vm.isNavbarCollapsed = true;
        vm.isAuthenticated = Principal.isAuthenticated;

        vm.login = login;
        vm.logout = logout;
        vm.toggleNavbar = toggleNavbar;
        vm.collapseNavbar = collapseNavbar;
		vm.setpagesize = setpagesize;

        if(!vm.isAuthenticated()){
            $state.go('login');
        }

		setPageTitle();
		getcannabinoidWorksheetIds();
		getCustomerData();

			function sampleHasReceivedDate(sample) {
				return !!(sample && (sample.receivedDate || sample.orderDateReceived ||
					(sample.order && (sample.order.dateReceived || sample.order.date_received)) ||
					(sample.customerOrder && (sample.customerOrder.dateReceived || sample.customerOrder.date_received))));
			}

		$scope.determineTestPf =  function(test, parentSample) {
			var html = null;

			html += '<tr>';

			html += '<tr><td>' + test.assay.title + '</td>';
			if (test.canSeeResults) {
				if (test.state == 'RETESTING') {
					html += '<td class="test-retesting">Retesting</td>';
				}
				else if (test.state == 'HOLD') {
					html += '<td class="test-hold">Hold</td>';
				}
				else if (test.caution) {
					html += '<td class="test-caution">Caution</td>';
				}
				else if (test.state == "NOT STARTED") {
					if(test.estimatedCompleteDate) {
						html += '<td class="test-in-progress">' + (sampleHasReceivedDate(parentSample) ? 'In Progress' : 'Not Received') + '</td>';
					}
					else {
						html += '<td class="test-not-started">Created</td>';
					}
			}
				else if (test.state == "IN PROGRESS") {
					html += '<td class="test-in-progress">In Progress</td>';
				}
				// Check statusPf first (works with GraphQL response that doesn't include worksheetData)
				else if (test.statusPf == 'PASS') {
					html += '<td class="test-pass">Pass</td>';
				}
				else if (test.statusPf == 'FAIL') {
					html += '<td class="test-fail">Fail</td>';
				}
				// Fallback to worksheetData checks for edge cases (e.g., do_not_show_pass_fail_in_portal)
				else if (test.worksheetData) {
					if (test.worksheetData.do_not_show_pass_fail_in_portal) {
						if (test.worksheetData.do_not_show_pass_fail_in_portal.value) {
							if (test.state == 'COMPLETED'){
								html += '<td class="test-no-pf-status">Tested<td>';
							}
							else {
								html += '<td class="test-in-progress">In Progress</td>';
							}
						}
						else if (test.state == 'COMPLETED'){
							html += '<td class="test-no-pf-status">Tested</td>';
						}
					}
					else if (test.worksheetData.findings_1){
						if (test.worksheetData.findings_1.value){
							html += '<td class="test-pass">Tested</td>';
						}
						else {
							html += '<td class="test-in-progress">In Progress</td>';
						}
					}
					else if (test.state == 'COMPLETED'){
						html += '<td class="test-no-pf-status">Tested</td>';
					}
					else {
						html += '<td class="test-in-progress">In Progress</td>';
					}
				}
				// Tests without worksheets but with results
				else if (test.results) {
					html += '<td class="test-pass">Tested</td>';
				}
				// Completed state without statusPf - show as Tested (not Final Review)
				else if (test.state == 'COMPLETED') {
					html += '<td class="test-no-pf-status">Tested</td>';
				}
				else {
					html += '<td class="test-fail">-</td>';
				}
			}
			else {
				if (test.state == 'RETESTING') {
					html += '<td class="test-retesting">Retesting</td>';
				}
				else if (test.state == 'HOLD') {
					html += '<td class="test-hold">Hold</td>';
				}
				else if (['PASS', "FAIL", "COMPLETED"].includes(test.state)) {
					html += '<td class="test-retesting">Final Review</td>';
				}
				else {
						html += '<td class="test-in-progress">' + (sampleHasReceivedDate(parentSample) ? 'In Progress' : 'Not Received') + '</td>';
				}
			}

			html += '</tr>';

			return html;
		}


        if(pagingParams.items != null){
            vm.itemsPerPage = pagingParams.items;
		}

        // Initialize default sample columns in case user does not have custom columns configured
        vm.sampleColumns = {
        		'lotNumber': true,
        		'name': true,
        		'productType': true,
        		'productCategory': true,
        		'thc': true,
        		'cbd': true,
				'alkaloids': true,
				'mitragynine': false,
        		'dateCompleted': true,
        		'weedmaps': false,
        		'public': false,
        		'downloads': true,
        		'sCode': false,
        		'totalCannabinoids': false,
        		'dateReceived': false,
        		'dateRequired': false,
        		'status': false,
        		'orderId': false
        }

        // Try to load cached column settings immediately to prevent flashing on page navigation
        var cachedColumns = sessionStorage.getItem('sampleLogColumns');
        if (cachedColumns) {
        	vm.sampleColumns = angular.extend({}, vm.sampleColumns, JSON.parse(cachedColumns));
        }

        vm.toggleEditColumns = function(){
        	vm.showEditColumns = !vm.showEditColumns;
        	if (vm.showEditColumns == true) {
        		// pass
        	} else {
        		saveSampleColumns();
        	}
        }

        vm.toggleWidget = function(name) {
        	if (vm.activeWidget === "sampleEditColumns") {
        		saveSampleColumns();
        	}

        	vm.activeWidget = name === vm.activeWidget ? null : name;
        }

        Principal.identity().then(function(account) {
        	vm.userAccount = account;
            if (account.userSettings) {
            	var userSettings = JSON.parse(account.userSettings);
            	if (userSettings.sample_columns){
            		// Merge user settings with defaults (so new columns get default values)
            		vm.sampleColumns = angular.extend({}, vm.sampleColumns, userSettings.sample_columns);
            		// Cache for instant restore on page navigation
            		sessionStorage.setItem('sampleLogColumns', JSON.stringify(vm.sampleColumns));
            	}
            }
		});

		function getcannabinoidWorksheetIds() {
			SampleService.getWorksheetParserMap({},
				function(data) {
					vm.cannabioidWorksheets = data.cannabinoid_profile;
					vm.alkaloidsWorksheets = data.alkaloid;
				},
				function(e) {
					console.log(e);
				}
			);
		}

        ProfileService.getProfileInfo().then(function(response) {
            vm.inProduction = response.inProduction;
            vm.swaggerEnabled = response.swaggerEnabled;
        });

        vm.sampleFilters = {
        		id: pagingParams.id,
        		orderId: pagingParams.orderId,
        		sampleName: pagingParams.sampleName,
        		lotNumber: pagingParams.lotNumber,
        		metrcId: pagingParams.metrcId,
        		categoryIdList: pagingParams.categoryIdList,
        		category: pagingParams.category,
        		subCategory: pagingParams.subCategory,
        		orderType: pagingParams.orderType,
        		thcLower: pagingParams.thcLower,
        		thcUpper: pagingParams.thcUpper,
        		cbdLower: pagingParams.cbdLower,
        		cbdUpper: pagingParams.cbdUpper,
        		isPass: pagingParams.isPass == 'true' ? pagingParams.isPass != null : null,
				isFail: pagingParams.isFail == 'true' ? pagingParams.isFail != null : null,
        		isUndetermined: pagingParams.isUndetermined == 'true' ? pagingParams.isUndetermined != null : null,
        		isWeedmapsSuccess: pagingParams.isWeedmapsSuccess == 'true' ? pagingParams.isWeedmapsSuccess != null : null,
        		isWeedmapsFail: pagingParams.isWeedmapsFail == 'true' ? pagingParams.isWeedmapsFail != null : null,
        		isWeedmapsNone: pagingParams.isWeedmapsNone == 'true' ? pagingParams.isWeedmapsNone: null,
        		visibility: pagingParams.visibility,
        		completeDateLower: pagingParams.completeDateLower ? convertLocalDateFromServer(pagingParams.completeDateLower) : null,
        		completeDateUpper: pagingParams.completeDateUpper ? convertLocalDateFromServer(pagingParams.completeDateUpper) : null,
        		estimatedDueDateLower: pagingParams.estimatedDueDateLower ? convertLocalDateFromServer(pagingParams.estimatedDueDateLower) : null,
        		estimatedDueDateUpper: pagingParams.estimatedDueDateUpper ? convertLocalDateFromServer(pagingParams.estimatedDueDateUpper) : null,
				starred: pagingParams.starred ? pagingParams.starred : null,
				isInProgress: pagingParams.isInProgress ? pagingParams.isInProgress : null,
				isCompleted: pagingParams.isCompleted ? pagingParams.isCompleted: null,
                sampleMatrix: pagingParams.sampleMatrix? pagingParams.sampleMatrix: null
        }

        vm.sort = function() {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate !== 'id') {
                result.push('id');
            }
            return result;
        }

        /* Filters */
        vm.page = pagingParams.page;
        vm.populateTypes = function() {
        	if (vm.sampleFilters.category) {
        		vm.productTypes = ProductTypeByCategory.query(vm.sampleFilters.category);
        	} else {
        		vm.productTypes = [];
        	}

        }
        vm.productCategories = ProductCategory.query();
		vm.applyFilters = applySampleFilters;

        function applySampleFilters() {
			// Parse filter criteria and add paging params
			var params = createFilterQueryParams();

        	// Send query
            SampleFilter.query(params, onSuccess, onError);
            function onSuccess(result, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.samples = result;
                vm.page = 0;
				vm.pagingParams = pagingParams;
            }
            function onError(error) {
            	console.log("Error applying filter");
            	console.log(error);
            }
        }

        function getFilterCount() {
			var totalFilters = 0;
        	for (var key in vm.sampleFilters) {
        		if (vm.sampleFilters[key] !== null && vm.sampleFilters[key] !== "" && vm.sampleFilters[key] !== undefined && vm.sampleFilters[key] !== false) {
					totalFilters++;
        		}
			}

			vm.totalFilters = totalFilters;
        	return totalFilters;
        }
        getFilterCount();
        vm.getFilterCount = getFilterCount;
        vm.filterSubmit = function() {
			vm.page = 1;
			vm.transition();
			vm.setTabViews();
			loadAll();  // Reload data with new filters
			fetchSampleCounts();  // Refresh tab counts with new filters
		}

		$scope.all = true;
		vm.switchTab = function(tab) {

			if (tab == 'starred') {
				$scope.starred = true
				$stateParams.starred = true;
			}
			else if (tab == 'isInProgress') {
				$scope.isInProgress = true
				$stateParams.isInProgress = true;
			}
			else if (tab == 'isCompleted') {
				$scope.isCompleted = true
				$stateParams.isCompleted = true;
			}
			else if (tab == 'total') {
				$scope.total = true
				$stateParams.total = true;
			}

			angular.forEach(vm.tabs, function(value, key) {
				if (key == tab) {
					vm.tabs[key] = true;
					$scope.activeTab = tab;
					pagingParams[key] = true;
					// Also update vm.sampleFilters for GraphQL
					if (key === 'isInProgress' || key === 'isCompleted' || key === 'starred') {
						vm.sampleFilters[key] = true;
					}
					$scope[key] ? $scope[key] = true : angular.noop;
					$stateParams[key] ? $stateParams[key] = true : angular.noop;
				}
				else {
					vm.tabs[key] = false;
					pagingParams[key] = false;
					// Also clear vm.sampleFilters for GraphQL
					if (key === 'isInProgress' || key === 'isCompleted' || key === 'starred') {
						vm.sampleFilters[key] = null;
					}
					$scope[key] ? $scope[key] = null : angular.noop;
					$stateParams[key] ? $stateParams[key] = null : angular.noop;
				}
			});
			getFilterCount();
			vm.filterSubmit();
		}

		vm.setTabViews = function() {
			if (pagingParams.starred) {
				$('#starred').addClass('active');
				$('#starred_controls').addClass('active');
				$('#isInProgress').removeClass('active');
				$('#total').removeClass('active');
				$('#isInProgress_controls').removeClass('active');
				$('#total_controls').removeClass('active');
				$('#isCompleted').removeClass('active');
				$('#isCompleted_controls').removeClass('active');
			}
			else if (pagingParams.isInProgress) {
				$('#isInProgress').addClass('active');
				$('#isInProgress_controls').addClass('active');
				$('#starred').removeClass('active');
				$('#total').removeClass('active');
				$('#starred_controls').removeClass('active');
				$('#total_controls').removeClass('active');
				$('#isCompleted').removeClass('active');
				$('#isCompleted_controls').removeClass('active');
			}
			else if (pagingParams.isCompleted) {
				$('#isCompleted').addClass('active');
				$('#isCompleted_controls').addClass('active');
				$('#starred').removeClass('active');
				$('#total').removeClass('active');
				$('#starred_controls').removeClass('active');
				$('#total_controls').removeClass('active');
				$('#isInProgress').removeClass('active');
				$('#isInProgress_controls').removeClass('active');
			}
			else {
				$('#total').addClass('active');
				$('#total_controls').addClass('active');
				$('#starred').removeClass('active');
				$('#isInProgress').removeClass('active');
				$('#starred_controls').removeClass('active');
				$('#isInProgress_controls').removeClass('active');
				$('#isCompleted').removeClass('active');
				$('#isCompleted_controls').removeClass('active');
			}
		}
		vm.setTabViews();

		vm.tabs = {
			total: totalOnly(),
			isInProgress: pagingParams.isInProgress ? pagingParams.isInProgress : false,
			starred: pagingParams.starred ? pagingParams.starred : false,
			isCompleted: pagingParams.isCompleted ?pagingParams.isCompleted : false,
			external: false
		}

		function totalOnly() {
			if (!pagingParams.isInProgress && !pagingParams.starred && !pagingParams.isCompleted) {
				return true;
			}
			else {
				return false;
			}
		}

        function createFilterQueryParams() {
        	var params = {};
            var dateFields = ["completeDateLower", "completeDateUpper", "estimatedDueDateLower", "estimatedDueDateUpper"];
        	for (var key in vm.sampleFilters) {
        		if (dateFields.indexOf(key) !== -1) {
         			params[key] = convertLocalDateFromServer(vm.sampleFilters[key]);
         		} else if (vm.sampleFilters[key] !== "" && vm.sampleFilters[key] !== null && vm.sampleFilters[key] !== undefined) {
        			params[key] = vm.sampleFilters[key];
        		}
        	}

        	params.page = vm.page;
        	params.sort = vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc');
            params.search = vm.currentSearch;
            params.size = vm.itemsPerPage;
            params.items = params.size;
			params.productCategoryId = vm.productCategoryId;


			angular.forEach(vm.tabs, function(value, key) {
				if (value == true) {
					pagingParams[key] = true;
				}
			});
        	return params;
		}


		function createAttributesCountDict() {
			var dict = {
				starred: [1],
				status: ['IN_PROGRESS'],
				status_copy: ['PASS', 'FAIL', 'COMPLETED'],
				total: [true]
			};

			var filters = Object.assign({}, vm.sampleFilters);
			filters.isInProgress = null;
			filters.starred = null;
			filters.isCompleted = null;

			var payload = {
				headers : dict,
				filters: filters
			}

			vm.filterCounts = {}
			return payload
		}

		function createStarredPayload() {
			var dict = {
				starred: 1,
			};

			var filters = Object.assign({}, vm.sampleFilters);
			filters.isInProgress = null;
			filters.starred = null;
			filters.isCompleted = null;

			var payload = {
				headers : dict,
				filters: filters
			}

			return payload
		}

		function getStarredSamplesCount() {
			// Use GraphQL to refresh starred count
			fetchSampleCounts();
		}

		// GraphQL-based tab counts
		function fetchSampleCounts() {
			var countQuery = [
				'query GetSampleCounts($filters: SampleFilters) {',
				'    sampleCounts(filters: $filters) {',
				'        total',
				'        starred',
				'        inProgress',
				'        completed',
				'    }',
				'}'
			].join('\n');

			// Remove state-specific filters for accurate counts
			var filters = buildGraphQLFilters();
			delete filters.isInProgress;
			delete filters.starred;
			delete filters.isCompleted;
			delete filters.isPass;
			delete filters.isFail;
			delete filters.isUndetermined;

			GraphQLService.query(countQuery, { filters: filters })
				.then(function(data) {
					vm.filterCounts = {
						total: data.sampleCounts.total,
						starred: data.sampleCounts.starred,
						isInProgress: data.sampleCounts.inProgress,
						isCompleted: data.sampleCounts.completed
					};
					// Cache counts and filter hash for page navigation
					sessionStorage.setItem('sampleLogCounts', JSON.stringify(vm.filterCounts));
					sessionStorage.setItem('sampleLogFilterHash', getFilterHash());
				})
				.catch(function(error) {
					console.error('Error fetching sample counts:', error);
				});
		}

		// Only fetch counts on initial load or when filters change (not page changes)
		// Create a hash of current filters to detect changes
		function getFilterHash() {
			var filters = buildGraphQLFilters();
			delete filters.isInProgress;
			delete filters.starred;
			delete filters.isCompleted;
			delete filters.isPass;
			delete filters.isFail;
			delete filters.isUndetermined;
			return JSON.stringify(filters);
		}

		var currentFilterHash = getFilterHash();
		var cachedFilterHash = sessionStorage.getItem('sampleLogFilterHash');
		var cachedCounts = sessionStorage.getItem('sampleLogCounts');

		// Only fetch counts if filters changed or no cache exists
		if (!cachedCounts || cachedFilterHash !== currentFilterHash) {
			fetchSampleCounts();
		} else {
			// Use cached counts
			vm.filterCounts = JSON.parse(cachedCounts);
		}

		// Cache key for totalItems includes tab state
		function getTotalItemsCacheKey() {
			var tabState = (pagingParams.starred ? 'starred' : '') +
						   (pagingParams.isInProgress ? 'inProgress' : '') +
						   (pagingParams.isCompleted ? 'completed' : '') +
						   (pagingParams.isPass ? 'pass' : '') +
						   (pagingParams.isFail ? 'fail' : '') || 'all';
			return 'sampleLogTotalItems_' + tabState + '_' + currentFilterHash;
		}

		// Load cached totalItems to prevent flashing
		var cachedTotalItems = sessionStorage.getItem(getTotalItemsCacheKey());
		if (cachedTotalItems) {
			vm.totalItems = parseInt(cachedTotalItems);
			vm.queryCount = vm.totalItems;
		}

        $scope.canSeeTest = function(sample, testName) {
        	var assayIdMap = {
        			'POTENCY_LCMSMS': 'Cannabinoid Profile',
        			'POTENCY_GCFID': 'Cannabinoid Profile',
        			'POTENCY_LCDAD': 'Cannabinoid Profile',
					'POTENCY_LCDAD_NON_PLANT': 'Cannabinoid Profile',
					'POTENCY_PLANT' : 'Cannabinoid Profile',
        			'RESIDUAL_SOLVENT_PHASE_II': 'Residual Solvents',
        			'RESIDUAL_SOLVENT_PHASE_I': 'Residual Solvents',
        			'HEAVY_METALS': 'Heavy Metals',
        			'HEAVY_METALS_FOOD': 'Heavy Metals',
        			'TERPENE_PROFILE': 'Terpene Profile',
        			'PESTICIDES_PLUS': 'Pesticide Screen',
        			'PESTICIDES_PHASE_II': 'Pesticide Screen',
        			'MICRO_QA_SCREEN': 'Microbiology',
        			'MICRO_PLUS': 'Microbiology',
        			'MICRO_INHALABLES': 'Microbiology',
        			'MICRO_NON_INHALABLES': 'Microbiology',
        			'MYCOTOXINS': 'Mycotoxins',
        			'WATER_ACTIVITY': 'Water Activity',
        			'FOREIGN_MATERIAL': 'Foreign Materials',
        			'MOISTURE': 'Moisture',
        			'SULFUR': 'Sulfur',
        			'HOMOGENEITY': 'Homogeneity',
        			'HOMOGENEITY_5': 'Homogeneity',
        			'PESTICIDES_MYCOTOXINS': 'Pesticides + Mycotoxins',
        			'ALKALOID': 'Alkaloid'
        	}
        	for (var i = 0; i < sample.sampleTests.length; i++) {
        		var test = assayIdMap[sample.sampleTests[i].assay.portalIdentifier];
        		if (test === testName) {
        			return sample.sampleTests[i].canSeeResults;
        		}
        	}
        }

        vm.downloadSamplesCsv = function downloadSamplesCsv () {

            var fileName = "samples.csv";
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            SampleExportService.downloadCsv().then(function (result) {
                var file = new Blob([result.data], {type: 'application/json'});
                var fileURL = window.URL.createObjectURL(file);
                a.href = fileURL;
                a.download = fileName;
                a.click();
            });


        }

		function padToTwo(number) {
            return `0${number}`.slice(-2);
		}

		function formatDate(date) {
            var month = date.getUTCMonth() + 1;
            var day = date.getUTCDate();
            var year = date.getUTCFullYear();

            return `${padToTwo(month)}/${padToTwo(day)}/${year}`;
        }

		vm.displayDueDate = function(sample) {
			if(sample.sampleTests.length == 0) return '-';
			var tests = sample.sampleTests;
			var test = null;
			var current_due_date = null;

			for(var test_index = 0; test_index < tests.length; test_index++) {
				test = tests[test_index];
				if(current_due_date == null) current_due_date = test.estimatedCompleteDate;
				if(test.estimatedCompleteDate != current_due_date) return "Various";
			}

            if(!current_due_date) return "-";

			try {
                current_due_date = new Date(current_due_date);
                if(current_due_date == 'Invalid Date') throw 'Invalid Date'

				return formatDate(current_due_date);
			}
			catch(e) {
				console.log(e);
                return current_due_date;
			}
		}

		vm.hasReceivedDate = sampleHasReceivedDate;

		vm.hasDueDate = function(sample) {
			if(!sample.sampleTests || sample.sampleTests.length == 0) return false;
			var test = sample.sampleTests[0];
			return test.estimatedCompleteDate != null && test.estimatedCompleteDate != undefined;
		}

        vm.updateSamplePublicity = function(sample) {
            vm.getAttachmentsLoader = false;
            sample.attachments = null;
            Sample.public({id: sample.id, public: sample.public});

        };

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.downloadSampleStartDate = false;
        vm.datePickerOpenStatus.downloadSampleEndDate = false;

		$scope.clickCount = 0;
        vm.openCalendar = function(date) {
			$scope.clickCount++;
            vm.datePickerOpenStatus[date] = true;
			if($scope.clickCount > 2 && vm.downloadSamplesError == true ){
				vm.downloadSamplesError = false;
			}

        }

        vm.downloadSample = {
        		startDate: null,
        		endDate: null,
        		type: 'COA'
        }

		$('#downloadSamplesModal').on('show.bs.modal', function () {
            vm.downloadSample.startDate = vm.sampleFilters.completeDateLower;
            vm.downloadSample.endDate = vm.sampleFilters.completeDateUpper;
            vm.downloadSamplesJobSubmitted = false;
            vm.downloadSamplesError = false;
            vm.downloadSamplesNull = false;
            if (!$scope.$$phase) {
                $scope.$apply();
            }
        });

        vm.downloadingSamples = false;
        vm.downloadSamplesError = false;
        vm.downloadSamplesErrorMsg = '';
        vm.downloadSamplesNull = false;
        vm.downloadSamplesJobSubmitted = false;

        vm.downloadSamples = function() {
        	vm.downloadSamplesError = false;
			vm.downloadSamplesErrorMsg = '';
        	vm.downloadSamplesNull = false;
        	vm.downloadSamplesJobSubmitted = false;

        	if (vm.downloadSample.type === "CSV" && (!vm.downloadSample.startDate || !vm.downloadSample.endDate)) {
        		vm.downloadSamplesError = true;
        		vm.downloadSamplesErrorMsg = 'CSV export requires both a start and end date.';
        		return;
        	}

        	if (vm.downloadSample.type !== "CSV" && !vm.downloadSample.startDate && !vm.downloadSample.endDate) {
        		vm.downloadSamplesError = true;
        		vm.downloadSamplesErrorMsg = 'Please select at least one date.';
        		return;
        	}

        	var sampleExportParams = {
                	startDate: vm.downloadSample.startDate ? vm.downloadSample.startDate.getTime()/1000 : null,
                	endDate: vm.downloadSample.endDate ? vm.downloadSample.endDate.getTime()/1000 : null,
                	type: vm.downloadSample.type
        	}
        	vm.downloadingSamples = true;

        	if (vm.downloadSample.type == "COA") {
            	SampleExportService.downloadCoa(sampleExportParams).then(function (result) {
                    var fileName = "samples";
                    if (sampleExportParams.startDate && sampleExportParams.endDate) {
                    	fileName += " " + $filter('date')(vm.downloadSample.startDate, 'MM-dd-yyyy') + " to " + $filter('date')(vm.downloadSample.endDate, 'MM-dd-yyyy');
                    } else if (sampleExportParams.startDate) {
                    	fileName += " after " + $filter('date')(vm.downloadSample.startDate, 'MM-dd-yyyy');
                    } else if (sampleExportParams.endDate) {
                    	fileName += " before " + $filter('date')(vm.downloadSample.endDate, 'MM-dd-yyyy');
                    }
                    fileName += ".zip";

            		downloadSamplesSuccess(fileName, result);

                }, function(error) {
                	downloadSamplesError(error);
                });
        	} else {
				var params = {};
				var dateFields = ["completeDateLower", "completeDateUpper", "estimatedDueDateLower", "estimatedDueDateUpper"];
				for (var key in vm.sampleFilters) {
					if (dateFields.indexOf(key) !== -1 && vm.sampleFilters[key] !== "" && vm.sampleFilters[key] !== null && vm.sampleFilters[key] !== undefined) {
						params[key] = convertLocalDateToServer(vm.sampleFilters[key]);
					} else if (vm.sampleFilters[key] !== "" && vm.sampleFilters[key] !== null && vm.sampleFilters[key] !== undefined) {
						params[key] = vm.sampleFilters[key];
					}
				}
				sampleExportParams.filter_details = params
            	SampleExportService.submitCsvExportJob(sampleExportParams).then(function (result) {
            		vm.downloadingSamples = false;
            		vm.downloadSamplesJobSubmitted = true;
                }, function(error) {
                	downloadSamplesError(error);
                });
        	}
        }

        /* Publish to weedmaps */
        vm.publishToWeedmapsArgs = {
        		id: null, // required
        		weedmapsListingId: null, // required
        		weedmapsMenuItemName: null, // required
        		weedmapsMenuItemCategory: null, // optional
        		weedmapsMenuItemId: null // optional
        }

        vm.publishToWeedmaps = function() {
        	function onSuccess(data) {
        		vm.publishToWeedmapsSuccess = true;
        		vm.publishingToWeedmaps = false;
        		$timeout(function(){
        			$('#publishToWeedmapsModal').modal('hide');
        			$state.reload();
        		},2000)
        	}
        	function onError(error) { vm.publishToWeedmapsSuccess = false; vm.publishingToWeedmaps = false; }

        	vm.publishingToWeedmaps = true;
        	Weedmaps.publish(vm.publishToWeedmapsArgs, onSuccess, onError);

        }

        vm.emailsPending = [""];
        vm.emailMessage = "";

        vm.sendPublicEmail = function (form) {
        	vm.emailsPending = $('#testtaginput').tagsinput('items')
        	vm.emailSubject = $('#emailSubject').val();
        	//Send The Email
        	if (form.$valid && vm.emailsPending.length > 0){
        		$('#sendPublicSampleButton').attr("disabled", true);
        		Sample.sendEmail({
        			emails: vm.emailsPending,
        			message: vm.emailMessage,
        			public_link: vm.emailSamplePublicLink,
        			pic_url: vm.currentPublicSample.picture,
        			id:vm.currentPublicSample.id,
        			totalTHC: getTotalThc(vm.currentPublicSample),
        			subject: vm.emailSubject
        		}, onSuccess, onError);
        	}
        	else {
        		if (vm.emailsPending.length == 0)
        			$('#emailValidation').show();
        		return
        	}
        	function onSuccess(data, headers) {
        		$('#emailModal').modal('hide');
        		$('#emailModalSuccess').modal('show');
        		$('#sendPublicSampleButton').attr("disabled", false);

	        }

	        function onError(error) {
	        	AlertService.error(error.data.message);
	        	vm.emailsPending = [""];
	            vm.emailMessage = "";
	            $('#sendPublicSampleButton').attr("disabled", false);

	        }
        }

    $('#emailModalSuccess').on('hidden.bs.modal', function() {
        	$('#testtaginput').tagsinput('removeAll');
        	$('#testtaginput').tagsinput('input')[0].placeholder = 'email@example.com';
        })

        vm.copyLink = function(id) {
    	  /* Get the text field */
    	  var copyText = document.getElementById(id);
    	  /* Select the text field */
    	  copyText.select();
    	  copyText.setSelectionRange(0, 99999); /*For mobile devices*/
    	  /* Copy the text inside the text field */
    	  document.execCommand("copy");
        }

        vm.currentPublicSample = null

        vm.createSamplePublicLink = function(sample) {
        	var hash = sample.hash;
        	var fullUrl = window.location.origin +"/#/ps/"+ sample.hash;
        	vm.currentPublicSample = sample;
        	return fullUrl;
        }

        vm.openWeedmapsModal = function(sample) {
        	if (!sample.complete || !sample.canSeeReport) {
        		AlertService.error("Sample " + sample.id + " is not yet ready to be published", null, 'top right');
        		return;
        	}
            vm.publishToWeedmapsArgs = {
            		id: sample.id, // required
            		weedmapsListingId: parseInt(sample.weedmapsListingId), // required
            		weedmapsMenuItemName: sample.weedmapsMenuItemName, // required
            		weedmapsMenuItemCategory: sample.weedmapsMenuItemCategory, // optional
            		weedmapsMenuItemId: sample.weedmapsMenuItemId // optional
            }
            vm.publishToWeedmapsSuccess = null;
        	$('#publishToWeedmapsModal').modal('show');
        }
        $('#publishToWeedmapsModal').on('hidden.bs.modal', function() { vm.publishToWeedmapsArgs = {}; });

        $scope.getReports = function (sample,id) {
	        vm.getReportsLoader = true;
	        vm.idOfSelectedSample = id;


	        if(sample.reports != null){
		        vm.getReportsLoader = false;
		        return;
	        }

	        SampleAttach.getReports({id: id}, onSuccess, onError);
	        function onSuccess(data, headers) {
		        vm.getReportsLoader = false;
		        sample.reports = data;

	        }
	        function onError(error) {
	        	AlertService.error(error.data.message);
	        }
		}

		$scope.removeElement = function (allAttachments, at) {
			return allAttachments.filter(function (attachment) {
				if (attachment.id !== at.id) return attachment;
			})

		}

		$scope.reorderAttachments = function (attach) {
			var allAttachments = attach.slice();
			var reordered = [];
            if (attach && attach.length) {
                var newOrder = ['_consolidated_coa', '_coa', '_qr_code', 'pictures'];
                newOrder.forEach(function (reg) {
                    attach.forEach(function (at, key) {
                        if (reg === '_consolidated_coa' && at.file_name.toLowerCase().includes('_consolidated_coa')){
							reordered.push(at);
							allAttachments = $scope.removeElement(allAttachments, at);
                        }
                        else if (reg === '_coa' && at.file_name.toLowerCase().includes('_coa')) {
							reordered.push(at);
							allAttachments = $scope.removeElement(allAttachments, at);
                        }
                        else if (reg === '_qr_code' && at.file_name.toLowerCase().includes('_qr_code')) {
							reordered.push(at);
							allAttachments = $scope.removeElement(allAttachments, at);
                        }
                        else if (reg ===  'pictures' && at.is_picture) {
							reordered.push(at);
							allAttachments = $scope.removeElement(allAttachments, at);
						}
                    })
                })
			}
			if (allAttachments.length) {
				for (var i = 0; i < allAttachments.length; i++){
					reordered.push(allAttachments[i]);
				}
			}
            return reordered;
    }

        function isLabelAttachment(attachment) {
            if (!attachment) {
                return false;
            }

            if (attachment.type === 'SAMPLE_LABEL_ATTACHMENT') {
                return true;
            }

            var fileName = ((attachment.file_name || '') + '').toLowerCase();
            return /(^labels?(?:\b|[_-])|[_\s-]labels?\b)/.test(fileName);
        }

        $scope.getAttachments = function (sample, id) {
	        vm.getAttachmentsLoader = true;
	        vm.idOfSelectedSample = id;

				if(sample.attachments != null){
					vm.getAttachmentsLoader = false;
					return;
				}

				SampleAttach.query({id: id}, onSuccess, onError);
				function onSuccess(data, headers) {
					var processed_attachments = [];

					vm.getAttachmentsLoader = false;
					sample.attachments = data;
					sample.attachments.forEach(function(attachment) {
						var fileName = attachment.file_name.toLowerCase();
						if (fileName.includes('coa')) {
							// Only include COA files if canSeeReport is true.
							if (sample.canSeeReport) {
								processed_attachments.push(attachment);
							}
						} else if (!isLabelAttachment(attachment)) {
							// For non-COA files, use the label rule.
							processed_attachments.push(attachment);
						}
					});
					
					sample.attachments = processed_attachments;
				}
				function onError(error) {
					AlertService.error(error.data.message);
				}
		}

        $scope.toggleVisibility = function(id, sample) {
        	Sample.toggleVisibility({id: id},onSuccess,onError);

        	function onSuccess (data, headers) {
        		sample.is_public = data.is_public
        	}

        	function onError(error) {

		    }
        }

        $scope.toggleStarred = function(id, sample) {
        	Sample.toggleStarred({id: id},onSuccess,onError);

        	function onSuccess (data, headers) {
				sample.starred = data.starred
				getStarredSamplesCount()
        	}

        	function onError(error) {

		    }
		}

		$scope.isWithForeignTest = function (sample) {
			var flag = false;
			var test = sample.sampleTests;
			if (test.length) {
				for (var i = 0; i < test.length; i++){
					var t = test[i];
					if (t.assay.portalIdentifier == 'FOREIGN_MATERIAL') flag = true;
				}
				return flag;
			} else return false;
		}

		$scope.isWithCDPHETest = function (sample) {
			var flag = false;
			var test = sample.sampleTests;
			if (test.length) {
				for (var i = 0; i < test.length; i++){
					var t = test[i];
					if (t.assay.portalIdentifier == 'CO_CDPHE') flag = true;
				}
				return flag;
			} else return false;
		}

		$scope.downloadAttachment = function (id_hash, sample) {
			if(id_hash) {
				if(id_hash == 'coa') {
					var a = document.createElement("a");
					document.body.appendChild(a);
					a.style = "display: none";
					SampleCoaPdfService.downloadPdf(sample.hash).then( function(result) {
						var file = new Blob([result.data], {
							type: 'application/pdf'
						});

						a.href = window.URL.createObjectURL(file);
						a.download = sample.id + '_COA_Summary.pdf';
						a.click();
					});
				}
				else if(['california', 'colorado'].includes(id_hash)) {
					SampleAttachDownload.getBadge({text: window.location.host + '/#/ps/' + sample.hash, state: id_hash}, onSuccess, onError);
					var capitalizedState = id_hash.charAt(0).toUpperCase() + id_hash.slice(1);

					function onSuccess(data, headers) {
						var a = document.createElement("a");
						document.body.appendChild(a);
						a.style = "display: none";

						var fileURL = window.URL.createObjectURL(data.data);
						a.href = fileURL;
						a.download = sample.id + '_' + capitalizedState + '_QR_Code_Badge.png';
						a.click();
					}
					function onError(error) {
						console.log(error);
					}

				}
				else {
					SampleAttachDownload.get({id: id_hash}, onSuccess, onError);

					function onSuccess(data, headers) {
						var a = document.createElement("a");
						document.body.appendChild(a);
						a.style = "display: none";

						var fileURL = window.URL.createObjectURL(data.data);
						a.href = fileURL;
						// Parse and sanitize filename from Content-Disposition header
						a.download = DownloadUtil.getFilenameFromContentDisposition(headers('content-disposition'));
						a.click();
					}
					function onError(error) {
						console.log(error);
					}
				}
			}
			sample.select = "";
		}

		$scope.starred = pagingParams.starred ? pagingParams.starred : false;

		vm.toggleStarredView = function() {
			$scope.starred = !$scope.starred;

			vm.filterSubmit();
		}

		$('#testtaginput').tagsinput({
			tagClass: function(item) {
				return 'custom-label label-email'
			}
		});

		$('#testtaginput').on('beforeItemAdd', function(event) {
			var email_re = "^\S+@\S+$";
			if (!event.item.match(/\S+@\S+\.\S+/)) {
				$('#emailValidation').show();
				event.cancel = true;
			} else {
				$('#emailValidation').hide();
				$('#testtaginput').tagsinput('input')[0].placeholder = '';
			}
		});

		$('#testtaginput').on('beforeItemRemove', function(event) {
			if ($('#testtaginput').tagsinput('input')[0].value.length > 0)
				event.cancel = true;
			  // event.item: contains the item
			  // event.cancel: set to true to prevent the item getting removed
		});

		$('#testtaginput').tagsinput('input')[0].type = 'email'
		/*
		 * Gallery View Variables and Functions
		 * */

		$rootScope.galleryView = pagingParams.galleryView ? pagingParams.galleryView : false;
		var picturesLoaded = false;

		// Watch for gallery view toggle to load pictures on-demand
		$rootScope.$watch('galleryView', function(newVal) {
			if (newVal && !picturesLoaded && vm.samples && vm.samples.length > 0) {
				loadAllPictures();
				picturesLoaded = true;
			}
		});

		/* Download Samples */
        function downloadSamplesSuccess(fileName, result) {
    		if (result.data.byteLength == 0) {
    			vm.downloadSamplesNull = true;
    			vm.downloadingSamples = false;
    			return;
    		}

            var a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";

            var file = new Blob([result.data], {type: 'application/json'});
            var fileURL = window.URL.createObjectURL(file);
            a.href = fileURL;
            a.download = fileName;
            a.click();
            vm.downloadingSamples = false;
        }
        function downloadSamplesError(err) {
            vm.downloadingSamples = false;
            vm.downloadSamplesError = true;

            // Handle both ArrayBuffer responses (old endpoints) and JSON responses (new job endpoint)
            if (err.data instanceof ArrayBuffer) {
                var decodedString = new TextDecoder("utf-8").decode(new Uint8Array(err.data));
                var jsonResponse = JSON.parse(decodedString);
                vm.downloadSamplesErrorMsg = jsonResponse.message;
            } else if (err.data && err.data.message) {
                vm.downloadSamplesErrorMsg = err.data.message;
            } else if (err.data && err.data.error) {
                vm.downloadSamplesErrorMsg = err.data.error;
            } else {
                vm.downloadSamplesErrorMsg = 'An error occurred while processing your request.';
            }

            if (err.status === 404) {
                vm.downloadSamplesErrorMsg = 'No samples found during selected dates, please select new dates.';
            }
        }

        $scope.clearBtn = function() {
            vm.downloadSample.startDate = '';
            vm.downloadSample.endDate = '';
            vm.downloadSamplesError = false;
            vm.downloadSamplesJobSubmitted = false;
        }

        /* Date Utils (import DateUtils service doesn't work) */
        function convertLocalDateFromServer(date) {
            if (date) {
                var dateString = date.split('-');
                return new Date(dateString[0], dateString[1] - 1, dateString[2]);
            }
            return null;
        }

        function convertLocalDateToServer(date) {
            if (date) {
                return $filter('date')(date, 'yyyy-MM-dd');
            } else {
                return null;
            }
        }

        /* Login/Logout */
        function login() {
            collapseNavbar();
            $state.go('login');
        }

        function logout() {
            collapseNavbar();
            Auth.logout();
            $state.go('login');
        }

        /* Navbar Toggle */
        function toggleNavbar() {
            vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
        }

        function collapseNavbar() {
            vm.isNavbarCollapsed = true;
        }


        function setPageTitle(){
            $rootScope.pageTitle = "Samples";
            $rootScope.searchVm = vm;
		}

		vm.customerType = "";

		// Try to load cached customer data immediately to prevent flashing
		var cachedCustomerData = sessionStorage.getItem('sampleLogCustomerData');
		if (cachedCustomerData) {
			var cached = JSON.parse(cachedCustomerData);
			vm.customerData = cached.customerData;
			vm.customerType = cached.customerType;
			vm.sampleColumnThc = cached.sampleColumnThc;
			vm.sampleColumnCbd = cached.sampleColumnCbd;
			vm.thcCbdFilterOptions = cached.thcCbdFilterOptions;
			vm.sampleColumnAlkaloids = cached.sampleColumnAlkaloids;
			vm.sampleColumnMitragynine = cached.sampleColumnMitragynine;
		}

        function getCustomerData () {
			// Skip fetch if we have cached data
			if (cachedCustomerData) {
				return;
			}

			CustomerByUser.get({}, onSuccess, onError);
            function onSuccess(data, headers) {
				var type_of_business = data.businessType.name.toLowerCase();
				vm.customerData = data;
				try {
					vm.customerType = data.businessType.name;
				}
				catch (error) {
					console.log(error);
				}
				if (type_of_business.includes('food')) {
					vm.customerData.consolidated_business_type = 'food';
					vm.sampleColumnThc = false;
					vm.sampleColumnCbd = false;
					vm.thcCbdFilterOptions = false;
					vm.sampleColumnAlkaloids = true;
					vm.sampleColumnMitragynine = true;
				}
				else if (type_of_business.includes('cannabis')) {
					vm.customerData.consolidated_business_type = 'cannabis';
					vm.sampleColumnThc = true;
					vm.sampleColumnCbd = true;
					vm.thcCbdFilterOptions = true;
					vm.sampleColumnAlkaloids = false;
					vm.sampleColumnMitragynine = false;
				}
				else if (type_of_business.includes('hemp')) {
					vm.customerData.consolidated_business_type = 'hemp';
					vm.sampleColumnThc = true;
					vm.sampleColumnCbd = true;
					vm.thcCbdFilterOptions = true;
					vm.sampleColumnAlkaloids = false;
					vm.sampleColumnMitragynine = false;
				}
				else if (type_of_business.includes('kratom')){
					vm.customerData.consolidated_business_type = 'kratom';
					hasAlkaloidsMitragynine();
					vm.sampleColumnThc = false;
					vm.sampleColumnCbd = false;
					vm.thcCbdFilterOptions = false;
					vm.sampleColumnAlkaloids = true;
					vm.sampleColumnMitragynine = true;
				}

				// Cache customer data to prevent flashing on page navigation
				sessionStorage.setItem('sampleLogCustomerData', JSON.stringify({
					customerData: vm.customerData,
					customerType: vm.customerType,
					sampleColumnThc: vm.sampleColumnThc,
					sampleColumnCbd: vm.sampleColumnCbd,
					thcCbdFilterOptions: vm.thcCbdFilterOptions,
					sampleColumnAlkaloids: vm.sampleColumnAlkaloids,
					sampleColumnMitragynine: vm.sampleColumnMitragynine
				}));
            }
            function onError(e) {
				console.log(e);
            }
		}
		vm.determinePotencyDisplayForMitragynineAndAlkaloids = function(sample,potencyType,show_dash) {
			if (!sample.sampleTests) {
				return '';
			}
			var potency = '';
			var ws = null;
			var val = 'twoDecimalFormattedValue';
			if(vm.alkaloidsWorksheets){
				for (var i = 0; i < sample.sampleTests.length; i++) {
					if(vm.alkaloidsWorksheets.includes(sample.sampleTests[i].assay.worksheet_id)) {
						if(sample.sampleTests[i].worksheetData) {
							ws = sample.sampleTests[i].worksheetData;
							if(ws[potencyType + '_percent']['value'] == '0') {
								potency = '0%';
							}
							else {
								potency = ws[potencyType + '_percent'][val] ? ws[potencyType + '_percent'][val] + ' %' : '';
							}
						}
					}
				}
			}
			if(show_dash) {
				return potency ? potency : '-';
			}
			else {
				return potency;
			}
		}
		
			vm.determinePotencyDisplay = function(sample, potencyType, total, show_dash) {
			if (!sample.sampleTests) {
				return '';
			}
			var potency = '';
			var ws = null;

			if(total) {
				potencyType = 'thc';
			}

			var val = 'twoDecimalFormattedValue';

			if(vm.cannabioidWorksheets) {
				for (var i = 0; i < sample.sampleTests.length; i++) {
					if(vm.cannabioidWorksheets.includes(sample.sampleTests[i].assay.worksheet_id)) {
						if(sample.sampleTests[i].worksheetData) {
							ws = sample.sampleTests[i].worksheetData;


							if(ws['total_' + potencyType + '_mgpp']){
								if(!total) {
									if(ws['total_' + potencyType + '_mgpp']['value'] == '0') {
										potency = '0 mg/pkg';
									}
									else {
										potency = ws['total_' + potencyType + '_mgpp'][val] ? ws['total_' + potencyType + '_mgpp'][val] + ' mg/pkg' : '';
									}
								}
								else {
									if( ws['total_mgpp']['value'] == '0') {
										potency = '0 mg/pkg';
									}
									else {
										potency = ws['total_mgpp'][val] ? ws['total_mgpp'][val] + ' mg/pkg' : '';
									}
								}
							}
							if(ws['units_per_package'] && [null, '', '1'].includes(ws['units_per_package']['value']) && ws['total_' + potencyType + '_mgpu'] && potency == '') {
								if(!total) {
									if(ws['total_' + potencyType + '_mgpu']['value'] == '0') {
										potency = '0 mg/serv';
									}
									else {
										potency = ws['total_' + potencyType + '_mgpu'][val] ? ws['total_' + potencyType + '_mgpu'][val] + ' mg/serv' : '';
									}
								}
								else {
									if(ws['total_mgpu']['value'] == '0') {
										potency = '0 mg/serv';
									}
									else {
										potency = ws['total_mgpu'][val] ? ws['total_mgpu'][val] + ' mg/serv' : '';
									}
								}
							}
							if(!(['0', 0, null].includes(ws['moisture']['value'])) && ws['total_' + potencyType + '_dry_percent'] && potency == '') {
								if(!total) {
									if(ws['total_' + potencyType + '_dry_percent']['value'] == '0') {
										potency = '0% (dry)';
									}
									else {
										potency = ws['total_' + potencyType + '_dry_percent'][val] ? ws['total_' + potencyType + '_dry_percent'][val] + ' % (dry)' : '';
									}
								}
								else {
									if(ws['total_dry_percent']['value'] == '0') {
										potency = '0% (dry)';
									}
									else {
										potency = ws['total_dry_percent'][val] ? ws['total_dry_percent'][val] + ' % (dry)' : '';
									}
								}
							}
							if(!potency) {
								if(!total) {
									if(ws['total_' + potencyType + '_percent']['value'] == '0') {
										potency = '0%';
									}
									else {
										potency = ws['total_' + potencyType + '_percent'][val] ? ws['total_' + potencyType + '_percent'][val] + ' %' : '';
									}
								}
								else {
									if(ws['total_percent']['value'] == '0') {
										potency = '0%';
									}
									else {
										potency = ws['total_percent'][val] ? ws['total_percent'][val] + ' %' : '';
									}
								}
							}
						}
					}
				}
			}

			if(show_dash) {
				return potency ? potency : '-';
			}
			else {
				return potency;
			}
		}


		// function hasAlkaloidsMitragynine(){
		// 	if (vm.userAccount.userSettings) {
		// 		console.log(vm.userAccount.userSettings,'vm.userAccount.userSettingsssssss');
		// 		vm.userAccount.userSettings = JSON.stringify({sample_columns: vm.columns});
		// 	} else {
		// 		var userSettings = JSON.parse(vm.userAccount.userSettings);
		// 			userSettings.sample_columns = vm.sampleColumns;
		// 			console.log(vm.sampleColumns.mitragynine,'vm.sampleColumns');
		// 			if(vm.sampleColumns && !vm.sampleColumns.mitragynine){
		// 				if(vm.customerData.consolidated_business_type.includes('food')){
		// 					vm.sampleColumns.mitragynine = true;
		// 				}
		// 				else{
		// 					vm.sampleColumns.mitragynine = false;
		// 				}
		// 			}
		// 	}
		// }

		function hasAlkaloidsMitragynine(){
			if(vm.customerData.consolidated_business_type.includes('kratom') ){
				vm.sampleColumns.alkaloids = true;
				vm.sampleColumns.mitragynine = true;
			}
			else{
				vm.sampleColumns.alkaloids = false;
				vm.sampleColumns.mitragynine = false;
			}
		}

		$scope.hasCannabinoids = function(sample) {
			if (!sample.sampleTests) {
				return false;
			}
			if(vm.cannabioidWorksheets) {
				for (var i=0; i < sample.sampleTests.length; i++) {
					if(!sample.sampleTests[i].assay) {
						continue;
					}

					if(vm.cannabioidWorksheets.includes(sample.sampleTests[i].assay.worksheet_id)) {
						return true;
					}
				}
			}
			return false;
		}

        function getTotalThc(sample) {
        	if (!sample.sampleTests) return;
        	for (var i = 0; i < sample.sampleTests.length; i++){
        		var test = sample.sampleTests[i];
        		if (!test.assay || !test.assay.portalIdentifier) continue;
        		var assay = test.assay.portalIdentifier;
        		if (assay === 'POTENCY_LCDAD' || assay === 'POTENCY_GCFID' || assay === 'POTENCY_LCMSMS' || assay === 'POTENCY_LCDAD_NON_PLANT') {
					if (test.worksheetData && test.worksheetData.total_dry_percent && test.worksheetData.total_dry_percent.twoDecimalFormattedValue) {
						return test.worksheetData.total_dry_percent.twoDecimalFormattedValue + ' %';
        			}
        		}
        	}
        	return 'N/A';
        }

        /* Edit Columns */
		function saveSampleColumns() {
			if (!vm.userAccount.userSettings) {
				vm.userAccount.userSettings = JSON.stringify({sample_columns: vm.columns});
			} else {
				var userSettings = JSON.parse(vm.userAccount.userSettings);
				userSettings.sample_columns = vm.sampleColumns;
				vm.userAccount.userSettings = JSON.stringify(userSettings);
			}
			// Cache to sessionStorage for instant restore on page navigation
			sessionStorage.setItem('sampleLogColumns', JSON.stringify(vm.sampleColumns));
			Auth.updateAccount(vm.userAccount);
		}

		/* Page loads */
        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
            fetchSampleCounts();  // Refresh tab counts for search
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = false;
            vm.currentSearch = null;
            vm.sampleFilters = {};
            vm.populateTypes();
            vm.transition();
            fetchSampleCounts();  // Refresh tab counts after clearing filters
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
			var params = createFilterQueryParams();

        	if ($rootScope.galleryView) {
        		params['galleryView'] = true;
        	}
        	else {
        		params['galleryView'] = null;
        	}

        	if ($scope.starred ||$stateParams.starred) {
				params['starred'] = true;
			}
        	else {
				params['starred'] = null;
			}

			if ($scope.isInProgress || $stateParams.isInProgress) {
				params['isInProgress'] = true;
			}
			else {
				params['isInProgress'] = null;
			}

			if ($scope.isCompleted || $stateParams.isCompleted) {
				params['isCompleted'] = true;
			}
			else {
				params['isCompleted'] = null;
			}

			$state.go('.', params, { notify: false, reload: false });
			vm.setTabViews();
			loadAll();
        }

        function setpagesize(pagesize) {
            vm.itemsPerPage = pagesize;
            loadAll ();
        }

		function extractPackageValues(samples) {
			samples.forEach( function (sample){
				sample.sampleTests.forEach( function (test){
					if (sample.order.order_type.toLowerCase().includes('compliance')) {
						test.canSeeResults = sample.canSeeReport;
					}
					if (test.worksheetData){
						if (test.worksheetData['total_thc_mgpp']){
							sample.thc_mgpp = test.worksheetData['total_thc_mgpp'].value;
						}
						if (test.worksheetData['total_cbd_mgpp']){
							sample.cbd_mgpp = test.worksheetData['total_cbd_mgpp'].value;
						}
						if (test.worksheetData['total_mgpp']){
							sample.total_mgpp = test.worksheetData['total_mgpp'].value;
						}
					}
				});
			});
		}

        /** Load ALL the Sample Images!
         * Ideally, make an endpoint to retrieve all of the sample images so you don't need to keep calling.
         * **/

        // Cache for test results (Tier 3 - on-demand loading)
        vm.testResultsCache = {};

        // Build GraphQL filters from current filter state
        function buildGraphQLFilters() {
            var filters = {};
            var sf = vm.sampleFilters;

            if (sf.id) filters.id = parseInt(sf.id);
            if (sf.orderId) filters.orderId = parseInt(sf.orderId);
            if (sf.sampleName) filters.sampleName = sf.sampleName;
            if (sf.lotNumber) filters.lotNumber = sf.lotNumber;
            if (sf.metrcId) filters.metrcId = sf.metrcId;
            if (sf.sampleMatrix) filters.sampleMatrix = sf.sampleMatrix;
            if (sf.categoryIdList && sf.categoryIdList.length) filters.categoryIdList = sf.categoryIdList;
            if (sf.category && sf.category.id) filters.categoryIdList = [sf.category.id];
            if (sf.subCategory && sf.subCategory.id) filters.subCategoryId = sf.subCategory.id;
            if (sf.orderType && sf.orderType !== 'ALL') filters.orderType = sf.orderType;
            if (sf.thcLower) filters.thcLower = parseFloat(sf.thcLower);
            if (sf.thcUpper) filters.thcUpper = parseFloat(sf.thcUpper);
            if (sf.cbdLower) filters.cbdLower = parseFloat(sf.cbdLower);
            if (sf.cbdUpper) filters.cbdUpper = parseFloat(sf.cbdUpper);
            if (sf.isPass) filters.isPass = true;
            if (sf.isFail) filters.isFail = true;
            if (sf.isUndetermined) filters.isUndetermined = true;
            // Tab filters - check both vm.sampleFilters and pagingParams (tabs update pagingParams directly)
            if (sf.isInProgress || pagingParams.isInProgress) filters.isInProgress = true;
            if (sf.isCompleted || pagingParams.isCompleted) filters.isCompleted = true;
            if (sf.starred || pagingParams.starred) filters.starred = true;
            if (sf.visibility) filters.visibility = sf.visibility;
            if (sf.isWeedmapsSuccess) filters.isWeedmapsSuccess = true;
            if (sf.isWeedmapsFail) filters.isWeedmapsFail = true;
            if (sf.isWeedmapsNone) filters.isWeedmapsNone = true;

            // Date filters
            if (sf.completeDateLower) {
                filters.completeDateLower = $filter('date')(sf.completeDateLower, 'yyyy-MM-dd');
            }
            if (sf.completeDateUpper) {
                filters.completeDateUpper = $filter('date')(sf.completeDateUpper, 'yyyy-MM-dd');
            }
            if (sf.estimatedDueDateLower) {
                filters.estimatedDueDateLower = $filter('date')(sf.estimatedDueDateLower, 'yyyy-MM-dd');
            }
            if (sf.estimatedDueDateUpper) {
                filters.estimatedDueDateUpper = $filter('date')(sf.estimatedDueDateUpper, 'yyyy-MM-dd');
            }

            // Search
            if (vm.currentSearch) {
                filters.search = vm.currentSearch;
            }

            return filters;
        }

        // Tier 2: Load potency data after initial render
        function loadPotencyData() {
            if (!vm.samples || vm.samples.length === 0) return;

            var sampleIds = vm.samples.map(function(s) { return s.id; });

            // Combined query for potency AND test results (avoids separate hover API call)
            var potencyQuery = [
                'query GetSamplesPotency($sampleIds: [Int!]!) {',
                '    samplesPotencyBatch(sampleIds: $sampleIds) {',
                '        sampleId',
                '        thc',
                '        cbd',
                '        totalCannabinoids',
                '        alkaloids',
                '        mitragynine',
                '        tests {',
                '            id',
                '            assayTitle',
                '            assayPortalIdentifier',
                '            assayWorksheetId',
                '            state',
                '            statusPf',
                '            canSeeResults',
                '            caution',
                '            estimatedCompleteDate',
                '        }',
                '    }',
                '}'
            ].join('\n');

            GraphQLService.query(potencyQuery, { sampleIds: sampleIds })
                .then(function(data) {
                    // Create lookup map
                    var potencyMap = {};
                    data.samplesPotencyBatch.forEach(function(p) {
                        potencyMap[p.sampleId] = p;
                    });

                    // Update samples with potency data AND test results
                    vm.samples.forEach(function(sample) {
                        var potency = potencyMap[sample.id];
                        if (potency) {
                            sample.thcDisplay = potency.thc;
                            sample.cbdDisplay = potency.cbd;
                            sample.totalCannabinoidsDisplay = potency.totalCannabinoids;
                            sample.alkaloidsDisplay = potency.alkaloids;
                            sample.mitragynineDisplay = potency.mitragynine;

                             // Store test results for hover (transformed to match expected structure)
                            sample.sampleTests = potency.tests.map(function(t) {
                                return {
                                    id: t.id,
                                    assay: {
                                        title: t.assayTitle,
                                        portalIdentifier: t.assayPortalIdentifier,
                                        worksheet_id: t.assayWorksheetId
                                    },
                                    state: t.state,
                                    statusPf: t.statusPf,
                                    canSeeResults: t.canSeeResults,
                                    caution: t.caution,
                                    estimatedCompleteDate: t.estimatedCompleteDate
                                };
                            });

                            // Cache test results so hover doesn't need to fetch
                            vm.testResultsCache[sample.id] = sample.sampleTests;
                        }
                        sample.potencyLoaded = true;
                    });
                })
                .catch(function(error) {
                    console.error('Error loading potency data:', error);
                    // Mark as loaded anyway so UI doesn't stay in loading state
                    vm.samples.forEach(function(sample) {
                        sample.potencyLoaded = true;
                    });
                });
        }

        // Hover tooltip: Use cached test results (loaded with potency data)
        // Falls back to API call only if user hovers before potency loads (rare)
        vm.loadTestResultsForHover = function(sample) {
            // Return if already loaded via potency batch
            if (sample.sampleTests && sample.sampleTests.length > 0) {
                return;
            }

            // Return cached if available
            if (vm.testResultsCache[sample.id]) {
                sample.sampleTests = vm.testResultsCache[sample.id];
                return;
            }

            // Fallback: fetch individually if hover happens before potency loads
            sample.testsLoading = true;

            var testQuery = [
                'query GetSampleTests($sampleId: Int!) {',
                '    sampleTestResults(sampleId: $sampleId) {',
                '        id',
                '        assayTitle',
                '        assayPortalIdentifier',
                '        assayWorksheetId',
                '        state',
                '        statusPf',
                '        canSeeResults',
                '        caution',
                '        estimatedCompleteDate',
                '    }',
                '}'
            ].join('\n');

            GraphQLService.query(testQuery, { sampleId: sample.id })
                .then(function(data) {
                    var tests = data.sampleTestResults.map(function(t) {
                        return {
                            id: t.id,
                            assay: {
                                title: t.assayTitle,
                                portalIdentifier: t.assayPortalIdentifier,
                                worksheet_id: t.assayWorksheetId
                            },
                            state: t.state,
                            statusPf: t.statusPf,
                            canSeeResults: t.canSeeResults,
                            caution: t.caution,
                            estimatedCompleteDate: t.estimatedCompleteDate
                        };
                    });

                    vm.testResultsCache[sample.id] = tests;
                    sample.sampleTests = tests;
                    sample.testsLoading = false;
                })
                .catch(function(error) {
                    console.error('Error loading test results:', error);
                    sample.testsLoading = false;
                    sample.sampleTests = [];
                });
        };

        function loadAll() {
            vm.loadingSamples = true;

            // GraphQL query for samples list (Tier 1 - fast initial load)
            var samplesQuery = [
                'query GetSamplesList($page: Int!, $size: Int!, $sort: String, $filters: SampleFilters) {',
                '    samplesList(page: $page, size: $size, sort: $sort, filters: $filters) {',
                '        samples {',
                '            id',
                '            name',
                '            hash',
                '            lotBatchNumber',
                '            status',
                '            starred',
                '            isPublic',
                '            canSeeReport',
                '            complete',
                '            rd',
                '            sCode',
                '            sampleMatrix',
                '            weedmapsState',
                '            orderId',
                '            orderDateReceived',
                '            orderDateCompleted',
                '            orderType',
                '            productCategoryName',
                '            productTypeName',
                '            strainName',
                '            strainType',
                '            dueDate',
                '            testCount',
                '        }',
                '        totalCount',
                '    }',
                '}'
            ].join('\n');

            var filters = buildGraphQLFilters();

            GraphQLService.query(samplesQuery, {
                page: vm.page || pagingParams.page || 1,
                size: parseInt(vm.itemsPerPage) || 10,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                filters: filters
            }).then(function(data) {
                // Transform GraphQL response to match existing sample structure
                vm.samples = data.samplesList.samples.map(function(sample) {
                    return {
                        id: sample.id,
                        name: sample.name,
                        hash: sample.hash,
                        lot_batch_number: sample.lotBatchNumber,
                        lotBatchNumber: sample.lotBatchNumber,
                        status: sample.status,
                        starred: sample.starred,
                        is_public: sample.isPublic,
                        isPublic: sample.isPublic,
                        canSeeReport: sample.canSeeReport,
                        can_see_report: sample.canSeeReport,
                        complete: sample.complete,
                        rd: sample.rd,
                        s_code: sample.sCode,
                        sCode: sample.sCode,
                        sample_matrix: sample.sampleMatrix,
                        sampleMatrix: sample.sampleMatrix,
                        weedmaps_state: sample.weedmapsState,
                        weedmapsState: sample.weedmapsState,

                        // Order info (nested for compatibility)
                        order_id: sample.orderId,
                        customerOrderId: sample.orderId,
                        order: {
                            id: sample.orderId,
                            date_received: sample.orderDateReceived,
                            dateReceived: sample.orderDateReceived,
                            date_completed: sample.orderDateCompleted,
                            dateCompleted: sample.orderDateCompleted,
                            order_type: sample.orderType
                        },
                        customerOrder: {
                            id: sample.orderId,
                            dateReceived: sample.orderDateReceived,
                            dateCompleted: sample.orderDateCompleted
                        },

                        // Product info
                        productCategory: sample.productCategoryName ? { name: sample.productCategoryName } : null,
                        productType: sample.productTypeName ? { name: sample.productTypeName } : null,
                        strainName: sample.strainName ? { name: sample.strainName } : null,
                        strainType: sample.strainType ? { name: sample.strainType } : null,

                        // Due date (pre-computed)
                        dueDateDisplay: sample.dueDate,

                        // Date fields for column display
                        receivedDate: sample.orderDateReceived,
                        dateCompleted: sample.orderDateCompleted,

                        // Initialize empty sampleTests (will be loaded on hover)
                        sampleTests: [],

                        // Potency loading state
                        potencyLoaded: false,
                        thcDisplay: null,
                        cbdDisplay: null,
                        totalCannabinoidsDisplay: null,
                        alkaloidsDisplay: null,
                        mitragynineDisplay: null,
                        testCount: sample.testCount
                    };
                }).filter(function(sample) {
					// Hide samples with no tests for non-compliance orders (food, R&D, medical device, etc.)
					if (sample.testCount === 0) {
						var orderType = sample.order && sample.order.order_type ? sample.order.order_type.toLowerCase() : '';
						// Only show samples with 0 tests if it's a compliance order
						if (!orderType.includes('compliance')) {
							return false;
						}
					}
					return true;
				});

                vm.totalItems = data.samplesList.totalCount;
                vm.queryCount = vm.totalItems;
                vm.loadingSamples = false;

                // Cache totalItems to prevent flashing on page navigation
                sessionStorage.setItem(getTotalItemsCacheKey(), vm.totalItems.toString());

                // Update pagination links
                vm.links = {
                    last: Math.ceil(vm.totalItems / parseInt(vm.itemsPerPage))
                };

                // Reset pictures loaded flag for new samples
                picturesLoaded = false;

                // Only load pictures if in gallery view
                if ($rootScope.galleryView) {
                    loadAllPictures();
                    picturesLoaded = true;
                }

                // Tier 2: Load potency data after render
                $timeout(function() {
                    loadPotencyData();
                }, 0);

            }).catch(function(error) {
                console.error('GraphQL Error loading samples:', error);
                AlertService.error('Failed to load samples');
                vm.loadingSamples = false;
            });

            function loadAllPictures() {
                if (!vm.samples || vm.samples.length === 0) return;

            	var sample_ids = [];
    	        for (var i = 0; i < vm.samples.length; i++) {
					sample_ids.push(vm.samples[i].hash);
    	        }
            	SampleAttach.getBulkPictures({ids: sample_ids}, onPicturesSuccess, onPicturesError);

            	function onPicturesSuccess(pictures) {
                	for (var i = 0; i < vm.samples.length; i++) {
                        if (pictures[vm.samples[i].id] && pictures[vm.samples[i].id][0]) {
                		    var pic = pictures[vm.samples[i].id][0].slice(-1)[0];
        	        	    vm.samples[i].picture = pic ? pic.url : "content/images/no_image_available-small.png";
                        } else {
                            vm.samples[i].picture = "content/images/no_image_available-small.png";
                        }
        	        }
            	}

            	function onPicturesError(error) {
                    console.error('Error loading pictures:', error);
            	}
            }
        }

        loadAll();
        if (vm.sampleFilters.category) {
        	vm.populateTypes();
		}

        angular.element(document).ready(function() {
            setTimeout(function () {

                $("#table tr:first > th").each(function(index, element) {
                    index++;
                    var addLi = "<li class='tbl-dot-" + index + "'><span class='tbl-dot'></span></li>";
                    $("ul.tbl-dots").append(addLi);
                });

                var num_col = $("#table tr:first > th").length;
                var constant = 2;
                var constant2 = constant + 1;

                var col_width = 100 / num_col;

                $(window).on("load resize",function(){
                  var winWidth = $(window).width();
                  if(768 >= winWidth) {
                      $("#table tr:first > th").css("width", col_width+"%");
                  }
                });

                $("#col-prev").click(function() {
                    constant -= 1;
                    constant2 -= 1;
                    if (constant == 2 || constant2 == 2) {
                        $("#col-prev").attr('disabled', 'disabled');
                        $("#col-next").prop("disabled", false);
                    }
                    $('.tbl-col-' + constant).show();
                    $('.tbl-col-' + constant2).show();
                    $('.tbl-dot-' + constant).removeClass('disabled').addClass('active');
                    var x = constant2 + 1;
                    $('.tbl-col-' + x).hide();
                    $('.tbl-dot-' + x).removeClass('active').addClass('disabled');
                    if(constant == 2 || constant2 >= 2){
                        $("#col-next").prop("disabled", false);
                    }
                });

                $("#col-next").click(function() {
                    constant += 1;
                    constant2 += 1;
                    $('.tbl-col-' + constant).show();
                    $('.tbl-col-' + constant2).show();
                    $('.tbl-dot-' + constant).removeClass('disabled').addClass('active');
                    $('.tbl-dot-' + constant2).removeClass('disabled').addClass('active');
                    var x = constant - 1;
                    var x2 = constant2 - 1;
                    $('.tbl-col-' + x).hide();
                    $('.tbl-dot-' + x).removeClass('active').addClass('disabled');
                    if (constant >= num_col || constant2 >= num_col) {
                        $("#col-next").attr('disabled', 'disabled');
                        $("#col-prev").prop("disabled", false);
                    }
                    $("#col-prev").prop("disabled", false);
                });

            }, 1000);
        });

    }
})();
